var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3367 14.041C48.8146 12.0889 47.2757 10.55 45.3236 10.0279C41.7827 9.0791 27.5871 9.0791 27.5871 9.0791C27.5871 9.0791 13.3915 9.0791 9.85054 10.0279C7.89848 10.55 6.35953 12.0889 5.83747 14.041C4.88867 17.5819 4.88867 27.2378 4.88867 27.2378C4.88867 27.2378 4.88867 36.8937 5.83747 40.4347C6.35953 42.3867 7.89848 43.9257 9.85054 44.4478C13.3915 45.3966 27.5871 45.3966 27.5871 45.3966C27.5871 45.3966 41.7827 45.3966 45.3236 44.4478C47.278 43.9257 48.8146 42.3867 49.3367 40.4347C50.2855 36.8937 50.2855 27.2378 50.2855 27.2378C50.2855 27.2378 50.2855 17.5819 49.3367 14.041ZM23.0474 35.1006V19.3751L36.6664 27.2378L23.0474 35.1006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.02711beded0ef107b0dfd3ef896e3770.svg";
export { ForwardRef as ReactComponent };